import { Button } from "@/components/ui"

/** Route-level error boundary: a stack trace never replaces the app. */
export function ErrorScreen({ error, reset }: { error: unknown; reset?: () => void }) {
  const msg = error instanceof Error ? error.message : String(error)
  return (
    <div className="min-h-[60vh] grid place-items-center px-4 text-center">
      <div className="max-w-md space-y-3">
        <img src="/lucy-logo.png" alt="" className="mx-auto h-12 w-12 rounded-full object-cover opacity-80" />
        <h1 className="text-lg font-semibold">Something went wrong</h1>
        <p className="text-sm text-muted-foreground break-words">{msg}</p>
        <div className="flex justify-center gap-2">
          {reset && <Button variant="outline" onClick={reset}>Try again</Button>}
          <Button onClick={() => window.location.assign("/chat")}>Back to chat</Button>
        </div>
      </div>
    </div>
  )
}
